var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Inject } from 'vue-property-decorator';
import { INJECT_UICORE_BUS, INJECT_UICORE_DESIGNER } from "../../../lib/utils/consts";
import { TriggersList } from "../../../lib/designer/UcdToolbar/TriggersToolbarWidget";
import MockButton from "../../../lib/comps/MaterialBox/MockButton";
let MoreToolbarWidget = class MoreToolbarWidget extends Vue {
  constructor() {
    super(...arguments);
    this.widgets = [{
      name: '编辑器设置',
      icon: 'cog',
      openDialog: (e, {
        designer
      }) => {
        designer.openSkeletonStyleDialog({
          place: e.target
        });
      }
    }, {
      name: '开发者工具',
      icon: 'search-plus',
      openDialog: (_, {
        designer
      }) => designer.openDevtool()
    }, {
      name: '上报维度定义',
      icon: 'edit',
      openDialog: (e, {
        designer
      }) => {
        designer.openCreateReportDialog({
          place: e.target
        });
      }
    }, {
      name: '全局插件的公共参数',
      icon: 'cubes',
      openDialog: (e, {
        designer
      }) => {
        designer.openGlobalComponentPluginArgsDialog({
          place: e.target
        });
      }
    }];
  }
  render() {
    const h = arguments[0];
    return h("a-tooltip", {
      "attrs": {
        "placement": "bottomRight"
      }
    }, [h("button", {
      "attrs": {
        "type": "button"
      },
      "class": "ucd-toolbar-button"
    }, [h("a-icon", {
      "attrs": {
        "type": "menu"
      }
    })]), h("template", {
      "slot": "title"
    }, [h("div", {
      "class": "ucd-toolbarPopMenu ucd-moreToolbarWidget"
    }, [this.widgets.map(widget => h("div", {
      "class": "ucd-toolbarPopMenu-item",
      "attrs": {
        "data-ucd-report-eid": widget.name
      },
      "on": {
        "click": e => {
          widget.openDialog(e, {
            designer: this.designer
          });
        }
      }
    }, [h("i", {
      "class": `fa fa-${widget.icon}`,
      "style": "width:14px"
    }), "\xA0", widget.name])), h("div", {
      "class": "ucd-toolbar-mockBox ucd-toolbarPopMenu-item"
    }, [h("div", {
      "class": "ucd-mockButton-box"
    }, [h(MockButton, {
      "attrs": {
        "buttonText": "前端Mock"
      }
    })])]), h(TriggersList, {
      "class": "ucd-trigger-list"
    })])])]);
  }
};
__decorate([Inject(INJECT_UICORE_DESIGNER)], MoreToolbarWidget.prototype, "designer", void 0);
__decorate([Inject(INJECT_UICORE_BUS)], MoreToolbarWidget.prototype, "uc", void 0);
MoreToolbarWidget = __decorate([Component({
  name: 'MoreToolbarWidget'
})], MoreToolbarWidget);
export default MoreToolbarWidget;
//# sourceMappingURL=MoreToolbarWidget.js.map
